/**
 * Shared @wordpress/i18n factory for @tpct plugins.
 *
 * Each plugin binds its own text domain once via createI18n(domain) and re-exports
 * the returned helpers from a thin local i18n module, so call sites stay `import { __ }`.
 * The text domain must match the plugin's domain registered in PHP; until translation
 * JSON is loaded (wp_set_script_translations) these return the source string unchanged.
 */
import {
  __ as wpI18n__,
  _n as wpI18n_n,
  _x as wpI18n_x,
  sprintf as wpI18nSprintf,
} from '@wordpress/i18n';

export type Translator = {
  __: (text: string) => string;
  _x_: (text: string, context: string) => string;
  _n_: (single: string, plural: string, count: number) => string;
  sprintf: (format: string, ...subs: (string | number)[]) => string;
};

export const createI18n = (domain: string): Translator => ({
  __: (text) => wpI18n__(text, domain),
  _x_: (text, context) => wpI18n_x(text, context, domain),
  _n_: (single, plural, count) => wpI18n_n(single, plural, count, domain),
  sprintf: (format, ...subs) =>
    (wpI18nSprintf as (format: string, ...subs: (string | number)[]) => string)(
      format,
      ...subs
    ),
});
